import {useTranslation} from "react-i18next";
import NoData from "../../../components/common/NoData.tsx";
import NotificationCard from "./components/NotificationCard.tsx";
import ArrowLeft from "../../../assets/icons/arrow-narrow-left.svg?react";
import Cheks from "../../../assets/icons/checks.svg?react";
import IconBellRinging from "@/assets/icons/bell-ringing.svg?react";
import PageWrapper from "@/components/PageWrapper.tsx";

export default function NotificationsPage() {
    const {t} = useTranslation();

    const data = [
        {
            id: 1,
            img: "https://picsum.photos/200/300",
            date: "2025-02-17T11:38:37+05:00",
            title: "DON mini-app’ga xush kelibsiz!",
            description: "Ilovaning barcha imkoniyatlaridan boxabar bo‘ling",
            button: "",
        },
        {
            id: 2,
            img: "",
            date: "2025-02-17T11:38:37+05:00",
            title: "Boshqa qurilmadan kirish aniqlandi",
            description: "IPhone 13,2-IOS 18.0-C%",
            button: "Xavfsizlik sozlamalariga o‘ting",
        },
        {
            id: 3,
            img: "",
            date: "2025-02-17T11:38:37+05:00",
            title: "HGT ilovasiga xush kelibsiz",
            description: "IPhone 13,2-IOS 18.0-C%",
            button: "",
        },
    ];
    // const data =[]

    return (
        <PageWrapper backPath="/">
            <div className="grid px-3 gap-3">
                <div className="flex py-2 justify-between items-center">
                    <ArrowLeft width="24px" height="24px"/>
                    <h1 className="text-center font-semibold leading-130 text-base">
                        {t("notification")}
                    </h1>
                    <Cheks width="24px" height="24px"/>
                </div>

                {data.length > 0 ? (
                    data.map((item) => <NotificationCard key={item.id} {...item} />)
                ) : (
                    <div className="flex-1 flex-center min-h-[60vh]">
                        <NoData
                            image={<IconBellRinging width="48px" height="48px"/>}
                            title={t("no_notification_title")}
                            description={t("no_notification_description")}
                        />
                    </div>
                )}
            </div>
        </PageWrapper>
    );
}
